// Textos comuns aos módulos do DP (26/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.hoje': 'Hoje',
    // A grade do mês e a linha do tempo, comuns às Ausências e aos Prazos de saúde e segurança.
    'dp.calendario.mesAnterior': 'Mês anterior',
    'dp.calendario.proximoMes': 'Próximo mês',
    'dp.calendario.semana.0': 'Dom',
    'dp.calendario.semana.1': 'Seg',
    'dp.calendario.semana.2': 'Ter',
    'dp.calendario.semana.3': 'Qua',
    'dp.calendario.semana.4': 'Qui',
    'dp.calendario.semana.5': 'Sex',
    'dp.calendario.semana.6': 'Sáb',
    'dp.calendario.maisN': '+ {{n}} mais',
    'dp.calendario.janela': 'Janela',
    'dp.calendario.janela.um': '1 mês',
    'dp.calendario.janela.tres': '3 meses',
    'dp.calendario.janelaDeMeses': '{{de}} a {{ate}}',
    'dp.comoFunciona': 'Como funciona',
    'dp.naoInformado': 'Não informado',
    'dp.competencia.fecharCurto': 'Fechar',
    'dp.retratoCurto': 'Lido em {{data}}',
    'dp.eyebrow': 'Departamento Pessoal',
    'dp.ultimaTratativa': 'Tratativa',
    'dp.carga.feita': 'Planilha importada.',
    'dp.carga.linhas': 'Linhas lidas',
    'dp.carga.gravadas': 'Novas',
    'dp.carga.atualizadas': 'Atualizadas',
    'dp.carga.mantidas': 'Sem mudança',
    'dp.carga.ignoradas': 'Fora do DP',
    'dp.carga.pendentes': 'Sem pessoa',
    'dp.carga.avisos': '{{n}} avisos na leitura:',
    'dp.carga.confirmar': 'Importar',
    'dp.importar': 'Importar',
    'dp.acoes': 'Ações',
    'dp.pessoa': 'Pessoa',
    'dp.matricula': 'Matrícula {{m}}',
    'dp.semMatricula': 'Sem matrícula',
    'dp.salvar': 'Salvar',
    'dp.todas': 'Todas',
    'dp.situacao': 'Situação',
    'dp.observacao': 'Observação',
    'dp.prazo': 'Prazo',
    'dp.ocultoSensivel': 'Valor oculto',
    'dp.cobrar': 'Cobrar',
    'dp.cobrancaCopiar': 'Copiar texto',
    'dp.cobrancaCopiado': 'Texto copiado.',
    'dp.cobrancaWhatsapp': 'Abrir no WhatsApp',
    'dp.cobrancaRegistrar': 'Registrar cobrança',
    'dp.cobrancaRegistrada': 'Cobrança registrada.',
    'dp.cobrancaSemTelefone': 'O cadastro não tem telefone: copie o texto e mande por outro caminho.',
    'dp.cobrancaTelefoneMascarado': 'O telefone termina em {{final}}. O número inteiro só aparece para quem vê CPF e telefone.',
    'dp.retrato': 'Retrato da {{origem}} de {{data}}',
    'dp.origem.planilha': 'planilha do DP',
    'dp.origem.api': 'leitura do Protheus',
    'dp.prazo.vencido': 'Venceu há {{dias}} dias',
    'dp.prazo.vencidoUm': 'Venceu ontem',
    'dp.prazo.hoje': 'Vence hoje',
    'dp.prazo.proximo': 'Vence em {{dias}} dias',
    'dp.prazo.proximoUm': 'Vence amanhã',
    'dp.prazo.emDia': 'Até {{data}}',
    'dp.prazo.concluido': 'Concluído',
    'dp.prazo.semPrazo': 'Sem prazo',
    'dp.competencia.rotulo': 'Competência',
    'dp.competencia.periodo': 'De {{inicio}} a {{fim}}',
    'dp.competencia.status.aberta': 'Aberta',
    'dp.competencia.status.em_conferencia': 'Em conferência',
    'dp.competencia.status.fechada': 'Fechada',
    'dp.competencia.naoAberta': 'Não aberta',
    'dp.competencia.conferir': 'Pôr em conferência',
    'dp.competencia.fechar': 'Fechar competência',
    'dp.competencia.reabrir': 'Reabrir',
    'dp.competencia.reabrirTitulo': 'Reabrir a competência {{rotulo}}',
    'dp.competencia.reabrirTexto': 'A competência fechada não muda mais. Reabrir fica registrado com a justificativa.',
    'dp.competencia.justificativa': 'Justificativa',
    'dp.competencia.fecharTitulo': 'Fechar a competência {{rotulo}}',
    'dp.competencia.fecharTexto': 'Depois de fechada, nenhuma linha muda até alguém reabrir com justificativa.',
    'dp.competencia.ultimaMudanca': 'Última mudança por {{quem}}',
    'dp.excel': 'Excel',
    'dp.busca': 'Buscar por nome ou matrícula',
    'dp.filial': 'Filial',
    'dp.todasFiliais': 'Todas as filiais',
    'dp.semResultado': 'Nada para mostrar com estes filtros.',
    'dp.tratativas.titulo': 'Tratativas de {{nome}}',
    'dp.tratativas.vazio': 'Nenhuma tratativa registrada.',
    'dp.tratativas.nova': 'Registrar tratativa',
    'dp.tratativas.tipo': 'Tipo',
    'dp.tratativas.tipo.cobranca': 'Cobrança',
    'dp.tratativas.tipo.anotacao': 'Anotação',
    'dp.tratativas.tipo.resposta': 'Resposta',
    'dp.tratativas.tipo.situacao': 'Situação',
    'dp.tratativas.tipo.importacao': 'Importação',
    'dp.tratativas.canal': 'Canal',
    'dp.tratativas.canal.whatsapp': 'WhatsApp',
    'dp.tratativas.canal.telefone': 'Telefone',
    'dp.tratativas.canal.email': 'E-mail',
    'dp.tratativas.canal.presencial': 'Presencial',
    'dp.tratativas.canal.outro': 'Outro',
    'dp.tratativas.texto': 'O que foi feito',
    'dp.tratativas.proxima': 'Cobrar de novo em',
    'dp.tratativas.salvar': 'Registrar',
    'dp.tratativas.salva': 'Tratativa registrada.',
    'dp.tratativas.por': 'Por {{quem}}',
    'dp.tratativas.proximaEm': 'Cobrar de novo em {{data}}',
    'dp.tratativas.botao': 'Tratativas',
    'dp.fechar': 'Fechar',
    'dp.cancelar': 'Cancelar',
    'dp.salvo': 'Salvo.',
  },
  en: {
    'dp.hoje': 'Today',
    'dp.calendario.mesAnterior': 'Previous month',
    'dp.calendario.proximoMes': 'Next month',
    'dp.calendario.semana.0': 'Sun',
    'dp.calendario.semana.1': 'Mon',
    'dp.calendario.semana.2': 'Tue',
    'dp.calendario.semana.3': 'Wed',
    'dp.calendario.semana.4': 'Thu',
    'dp.calendario.semana.5': 'Fri',
    'dp.calendario.semana.6': 'Sat',
    'dp.calendario.maisN': '+ {{n}} more',
    'dp.calendario.janela': 'Window',
    'dp.calendario.janela.um': '1 month',
    'dp.calendario.janela.tres': '3 months',
    'dp.calendario.janelaDeMeses': '{{de}} to {{ate}}',
    'dp.comoFunciona': 'How it works',
    'dp.naoInformado': 'Not provided',
    'dp.competencia.fecharCurto': 'Close',
    'dp.retratoCurto': 'Read on {{data}}',
    'dp.eyebrow': 'Personnel Department',
    'dp.ultimaTratativa': 'Follow-up',
    'dp.carga.feita': 'Spreadsheet imported.',
    'dp.carga.linhas': 'Rows read',
    'dp.carga.gravadas': 'New',
    'dp.carga.atualizadas': 'Updated',
    'dp.carga.mantidas': 'Unchanged',
    'dp.carga.ignoradas': 'Outside HR scope',
    'dp.carga.pendentes': 'No person',
    'dp.carga.avisos': '{{n}} warnings while reading:',
    'dp.carga.confirmar': 'Import',
    'dp.importar': 'Import',
    'dp.acoes': 'Actions',
    'dp.pessoa': 'Person',
    'dp.matricula': 'Employee ID {{m}}',
    'dp.semMatricula': 'No employee ID',
    'dp.salvar': 'Save',
    'dp.todas': 'All',
    'dp.situacao': 'Status',
    'dp.observacao': 'Note',
    'dp.prazo': 'Deadline',
    'dp.ocultoSensivel': 'Hidden value',
    'dp.cobrar': 'Follow up',
    'dp.cobrancaCopiar': 'Copy text',
    'dp.cobrancaCopiado': 'Text copied.',
    'dp.cobrancaWhatsapp': 'Open in WhatsApp',
    'dp.cobrancaRegistrar': 'Log follow-up',
    'dp.cobrancaRegistrada': 'Follow-up logged.',
    'dp.cobrancaSemTelefone': 'The record has no phone: copy the text and send it another way.',
    'dp.cobrancaTelefoneMascarado': 'The phone ends in {{final}}. The full number only shows to whoever can see ID and phone.',
    'dp.retrato': 'Snapshot from the {{origem}} of {{data}}',
    'dp.origem.planilha': 'HR spreadsheet',
    'dp.origem.api': 'Protheus reading',
    'dp.prazo.vencido': 'Overdue by {{dias}} days',
    'dp.prazo.vencidoUm': 'Overdue since yesterday',
    'dp.prazo.hoje': 'Due today',
    'dp.prazo.proximo': 'Due in {{dias}} days',
    'dp.prazo.proximoUm': 'Due tomorrow',
    'dp.prazo.emDia': 'By {{data}}',
    'dp.prazo.concluido': 'Done',
    'dp.prazo.semPrazo': 'No deadline',
    'dp.competencia.rotulo': 'Pay period',
    'dp.competencia.periodo': 'From {{inicio}} to {{fim}}',
    'dp.competencia.status.aberta': 'Open',
    'dp.competencia.status.em_conferencia': 'Under review',
    'dp.competencia.status.fechada': 'Closed',
    'dp.competencia.naoAberta': 'Not opened',
    'dp.competencia.conferir': 'Send to review',
    'dp.competencia.fechar': 'Close period',
    'dp.competencia.reabrir': 'Reopen',
    'dp.competencia.reabrirTitulo': 'Reopen the {{rotulo}} pay period',
    'dp.competencia.reabrirTexto': 'A closed period no longer changes. Reopening is recorded with the reason.',
    'dp.competencia.justificativa': 'Reason',
    'dp.competencia.fecharTitulo': 'Close the {{rotulo}} pay period',
    'dp.competencia.fecharTexto': 'Once closed, no row changes until someone reopens it with a reason.',
    'dp.competencia.ultimaMudanca': 'Last change by {{quem}}',
    'dp.excel': 'Excel',
    'dp.busca': 'Search by name or employee number',
    'dp.filial': 'Branch',
    'dp.todasFiliais': 'All branches',
    'dp.semResultado': 'Nothing to show with these filters.',
    'dp.tratativas.titulo': 'Follow ups for {{nome}}',
    'dp.tratativas.vazio': 'No follow up recorded.',
    'dp.tratativas.nova': 'Record a follow up',
    'dp.tratativas.tipo': 'Type',
    'dp.tratativas.tipo.cobranca': 'Reminder',
    'dp.tratativas.tipo.anotacao': 'Note',
    'dp.tratativas.tipo.resposta': 'Reply',
    'dp.tratativas.tipo.situacao': 'Status',
    'dp.tratativas.tipo.importacao': 'Import',
    'dp.tratativas.canal': 'Channel',
    'dp.tratativas.canal.whatsapp': 'WhatsApp',
    'dp.tratativas.canal.telefone': 'Phone',
    'dp.tratativas.canal.email': 'Email',
    'dp.tratativas.canal.presencial': 'In person',
    'dp.tratativas.canal.outro': 'Other',
    'dp.tratativas.texto': 'What was done',
    'dp.tratativas.proxima': 'Remind again on',
    'dp.tratativas.salvar': 'Record',
    'dp.tratativas.salva': 'Follow up recorded.',
    'dp.tratativas.por': 'By {{quem}}',
    'dp.tratativas.proximaEm': 'Remind again on {{data}}',
    'dp.tratativas.botao': 'Follow ups',
    'dp.fechar': 'Close',
    'dp.cancelar': 'Cancel',
    'dp.salvo': 'Saved.',
  },
  es: {
    'dp.hoje': 'Hoy',
    'dp.calendario.mesAnterior': 'Mes anterior',
    'dp.calendario.proximoMes': 'Mes siguiente',
    'dp.calendario.semana.0': 'Dom',
    'dp.calendario.semana.1': 'Lun',
    'dp.calendario.semana.2': 'Mar',
    'dp.calendario.semana.3': 'Mié',
    'dp.calendario.semana.4': 'Jue',
    'dp.calendario.semana.5': 'Vie',
    'dp.calendario.semana.6': 'Sáb',
    'dp.calendario.maisN': '+ {{n}} más',
    'dp.calendario.janela': 'Ventana',
    'dp.calendario.janela.um': '1 mes',
    'dp.calendario.janela.tres': '3 meses',
    'dp.calendario.janelaDeMeses': '{{de}} a {{ate}}',
    'dp.comoFunciona': 'Cómo funciona',
    'dp.naoInformado': 'No informado',
    'dp.competencia.fecharCurto': 'Cerrar',
    'dp.retratoCurto': 'Leído el {{data}}',
    'dp.eyebrow': 'Departamento de Personal',
    'dp.ultimaTratativa': 'Gestión',
    'dp.carga.feita': 'Planilla importada.',
    'dp.carga.linhas': 'Filas leídas',
    'dp.carga.gravadas': 'Nuevas',
    'dp.carga.atualizadas': 'Actualizadas',
    'dp.carga.mantidas': 'Sin cambios',
    'dp.carga.ignoradas': 'Fuera del DP',
    'dp.carga.pendentes': 'Sin persona',
    'dp.carga.avisos': '{{n}} avisos en la lectura:',
    'dp.carga.confirmar': 'Importar',
    'dp.importar': 'Importar',
    'dp.acoes': 'Acciones',
    'dp.pessoa': 'Persona',
    'dp.matricula': 'Matrícula {{m}}',
    'dp.semMatricula': 'Sin matrícula',
    'dp.salvar': 'Guardar',
    'dp.todas': 'Todas',
    'dp.situacao': 'Situación',
    'dp.observacao': 'Observación',
    'dp.prazo': 'Plazo',
    'dp.ocultoSensivel': 'Valor oculto',
    'dp.cobrar': 'Cobrar',
    'dp.cobrancaCopiar': 'Copiar texto',
    'dp.cobrancaCopiado': 'Texto copiado.',
    'dp.cobrancaWhatsapp': 'Abrir en WhatsApp',
    'dp.cobrancaRegistrar': 'Registrar cobro',
    'dp.cobrancaRegistrada': 'Cobro registrado.',
    'dp.cobrancaSemTelefone': 'El registro no tiene teléfono: copie el texto y envíelo por otro medio.',
    'dp.cobrancaTelefoneMascarado': 'El teléfono termina en {{final}}. El número completo solo aparece para quien ve documento y teléfono.',
    'dp.retrato': 'Retrato de la {{origem}} del {{data}}',
    'dp.origem.planilha': 'planilla del DP',
    'dp.origem.api': 'lectura del Protheus',
    'dp.prazo.vencido': 'Venció hace {{dias}} días',
    'dp.prazo.vencidoUm': 'Venció ayer',
    'dp.prazo.hoje': 'Vence hoy',
    'dp.prazo.proximo': 'Vence en {{dias}} días',
    'dp.prazo.proximoUm': 'Vence mañana',
    'dp.prazo.emDia': 'Hasta {{data}}',
    'dp.prazo.concluido': 'Concluido',
    'dp.prazo.semPrazo': 'Sin plazo',
    'dp.competencia.rotulo': 'Período de nómina',
    'dp.competencia.periodo': 'Del {{inicio}} al {{fim}}',
    'dp.competencia.status.aberta': 'Abierta',
    'dp.competencia.status.em_conferencia': 'En revisión',
    'dp.competencia.status.fechada': 'Cerrada',
    'dp.competencia.naoAberta': 'No abierta',
    'dp.competencia.conferir': 'Pasar a revisión',
    'dp.competencia.fechar': 'Cerrar período',
    'dp.competencia.reabrir': 'Reabrir',
    'dp.competencia.reabrirTitulo': 'Reabrir el período {{rotulo}}',
    'dp.competencia.reabrirTexto': 'El período cerrado ya no cambia. Reabrir queda registrado con la justificación.',
    'dp.competencia.justificativa': 'Justificación',
    'dp.competencia.fecharTitulo': 'Cerrar el período {{rotulo}}',
    'dp.competencia.fecharTexto': 'Una vez cerrado, ninguna fila cambia hasta que alguien lo reabra con justificación.',
    'dp.competencia.ultimaMudanca': 'Último cambio por {{quem}}',
    'dp.excel': 'Excel',
    'dp.busca': 'Buscar por nombre o matrícula',
    'dp.filial': 'Sucursal',
    'dp.todasFiliais': 'Todas las sucursales',
    'dp.semResultado': 'Nada para mostrar con estos filtros.',
    'dp.tratativas.titulo': 'Gestiones de {{nome}}',
    'dp.tratativas.vazio': 'Ninguna gestión registrada.',
    'dp.tratativas.nova': 'Registrar gestión',
    'dp.tratativas.tipo': 'Tipo',
    'dp.tratativas.tipo.cobranca': 'Cobro',
    'dp.tratativas.tipo.anotacao': 'Anotación',
    'dp.tratativas.tipo.resposta': 'Respuesta',
    'dp.tratativas.tipo.situacao': 'Situación',
    'dp.tratativas.tipo.importacao': 'Importación',
    'dp.tratativas.canal': 'Canal',
    'dp.tratativas.canal.whatsapp': 'WhatsApp',
    'dp.tratativas.canal.telefone': 'Teléfono',
    'dp.tratativas.canal.email': 'Correo',
    'dp.tratativas.canal.presencial': 'Presencial',
    'dp.tratativas.canal.outro': 'Otro',
    'dp.tratativas.texto': 'Qué se hizo',
    'dp.tratativas.proxima': 'Cobrar de nuevo el',
    'dp.tratativas.salvar': 'Registrar',
    'dp.tratativas.salva': 'Gestión registrada.',
    'dp.tratativas.por': 'Por {{quem}}',
    'dp.tratativas.proximaEm': 'Cobrar de nuevo el {{data}}',
    'dp.tratativas.botao': 'Gestiones',
    'dp.fechar': 'Cerrar',
    'dp.cancelar': 'Cancelar',
    'dp.salvo': 'Guardado.',
  },
}
